const validationFormMixin = {
  methods: {
    getValidationClass(...fieldsName) {
      const field = fieldsName.reduce(
        (acc, fieldName) => acc[fieldName],
        this.$v.form
      )

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}

export default validationFormMixin
